@if (item.type === 'SIMPLE') {
  <div class="palantir-entity-change-log-item">
    <palantir-toolbar>
      <palantir-toolbar-prefix>
        @if (item.avatar) {
          <palantir-avatar>
            @if (item.avatar.src) {
              <img [src]="item.avatar.src" alt="User avatar" />
            }

            @if (item.avatar.icon) {
              <palantir-icon [name]="item.avatar.icon" />
            }
          </palantir-avatar>
        }

        <palantir-toolbar-content>
          @if (item.title) {
            <palantir-text type="title" size="base" palantir-toolbar-main-title>{{
              item.title
            }}</palantir-text>
          }
          <palantir-text type="description" size="base" palantir-toolbar-main-subtitle>
            {{ item.description }}
          </palantir-text>
        </palantir-toolbar-content>
      </palantir-toolbar-prefix>
    </palantir-toolbar>
  </div>
}

@if (item.type === 'RATING') {
  <div class="palantir-entity-change-log-item palantir-entity-change-log-item--rating">
    <div class="palantir-entity-change-log-item__block">
      <palantir-text type="subtitle">{{ item.ratingTitle }}</palantir-text>
      <palantir-stars [value]="item.rating" />
    </div>

    @if (item.descriptionText) {
      <div class="palantir-entity-change-log-item__block">
        <palantir-text type="subtitle">{{ item.descriptionTitle }}</palantir-text>
        <palantir-text>{{ item.descriptionText }}</palantir-text>
      </div>
    }
  </div>
}

@if (item.type === 'DIFF') {
  <div class="palantir-entity-change-log-item palantir-entity-change-log-item--diff">
    <div class="palantir-entity-change-log-item__block">
      <palantir-tag color="red">{{ item.beforeText }}</palantir-tag>
      @for (diffItem of item.beforeItems; track $index) {
        <palantir-entity-change-log-item [item]="diffItem" />
      }
    </div>

    <div class="palantir-entity-change-log-item__block">
      <palantir-tag color="green">{{ item.afterText }}</palantir-tag>
      @for (diffItem of item.afterItems; track $index) {
        <palantir-entity-change-log-item [item]="diffItem" />
      }
    </div>
  </div>
}

@if (item.type === 'MAP') {
  <div class="palantir-entity-change-log-item--map">
    <palantir-map
      [key]="item.type"
      [center]="item.center"
      [zoom]="item.zoom"
      [markers]="item.markers"
      [mapId]="item.mapId"
    />
  </div>
}
